"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
// @ts-nocheck
const Crop_1 = __importDefault(require("@becrop/abstract/Models/Crop"));
const Client_1 = __importDefault(require("@becrop/abstract/Models/Client"));
const Sample_1 = require("@becrop/abstract/Models/Sample");
const project_1 = require("@becrop/components/Results/Abstract/Interfaces/project");
// import { fake } from './fakeFarms';
const GeoEntities_1 = require("@becrop/abstract/Models/GeoEntities");
const Acreage_1 = __importDefault(require("@becrop/components/Modules/Common/Models/Acreage"));
const Tabular_1 = require("@becrop/abstract/Models/Tabular");
const axios_1 = __importDefault(require("axios"));
const Tabular_2 = require("../../../../abstract/Models/Tabular");
class TabularController {
    constructor() {
        this.farms = new Array();
        this.fields = new Array();
        this.samples = new Array();
        this.tabularSet = new Tabular_1.TabularFieldSet(this.fields);
        this.tabularSampleSet = new Tabular_2.TabularSampleSet(this.samples);
        this.scope = 'fields';
        this.loading = false;
    }
    static getInstance() {
        if (this._instance)
            return this._instance;
        this._instance = new TabularController();
        return this._instance;
    }
    // get fake() {
    //     return '';//fake
    // }
    async fetchFarms() {
        // this.buildFarmFromResponse(this.fake)
        // this.tabularize()
        this.loading = true;
        const response = axios_1.default.get('/farms/api/fields-details')
            .then((response) => this.buildFarmFromResponse(response.data))
            .catch((error) => console.error({ error }))
            .finally(() => {
            this.tabularize();
            this.loading = false;
        });
    }
    async fetchSamples() {
        /*         this.buildFarmFromResponse(this.fake)
                this.tabularize() */
        this.loading = true;
        const response = axios_1.default.get('/farms/api/samples-results')
            .then((response) => this.buildSamplesFromResponse(response.data))
            .catch((error) => console.error({ error }))
            .finally(() => {
            this.tabularizeSamples();
            this.loading = false;
        });
    }
    async fetchFieldMetrics(fieldId, farmId) {
        var _a, _b;
        console.log('fetchFieldMetrics');
        const response = await axios_1.default.get(`/farms/api/fields-results?farm_id=${farmId}&field_id=${fieldId}`);
        const farmData = ((_a = response.data.farms) === null || _a === void 0 ? void 0 : _a.filter((farm) => farm.id === farmId)[0]) || [];
        const metricData = ((_b = farmData.fields) === null || _b === void 0 ? void 0 : _b.filter((field) => field.id === fieldId)[0].metricCategories) || [];
        console.log({ metricData });
        return metricData;
    }
    buildFarmFromResponse(data) {
        const farms = data.farms.map((farm) => new GeoEntities_1.Farm({
            "name": farm.name,
            "id": farm.id,
            "client": new Client_1.default({ 'name': farm.client.name, 'code': farm.client.code }),
            "fields": farm.fields.map((fi) => {
                const metrics = [];
                fi.metricCategories.forEach((mc) => {
                    mc.metrics.forEach((me) => {
                        const scale = (me.scale) ?
                            me.scale :
                            (me.code.startsWith('SO')) ?
                                'hlt' :
                                'std';
                        const newMetric = new project_1.BioMetric({
                            'name': me.name,
                            'code_name': me.code,
                        }, {
                            'category': mc.name,
                        });
                        newMetric.scale = scale;
                        newMetric.setScore(parseFloat(me.score));
                        metrics.push(newMetric);
                    });
                });
                return new GeoEntities_1.Field({
                    "areaID": farm.id,
                    "farm": farm.name,
                    "client": new Client_1.default({ 'name': farm.client.name, 'code': farm.client.code }),
                    "id": fi.id,
                    "gis_field_id": fi.gis_field_id,
                    "name": fi.name,
                    "polygon": fi.geodata,
                    "crop": new Crop_1.default({
                        "id": fi.crop.id,
                        "name": fi.crop.name,
                        "color": fi.crop.color,
                        "icon": fi.crop.logo
                    }),
                    acreage: new Acreage_1.default(parseFloat(fi.acreage), 'ha'),
                    "metrics": metrics
                });
            })
        }));
        this.farms = farms;
    }
    buildSamplesFromResponse(data) {
        const samples = data.samples.map((sample) => {
            const metrics = [];
            sample.metricCategories.forEach((mc) => {
                mc.metrics.forEach((me) => {
                    const scale = (me.scale) ?
                        me.scale :
                        (me.code.startsWith('SO')) ?
                            'hlt' :
                            'std';
                    const newMetric = new project_1.BioMetric({
                        'name': me.name,
                        'code_name': me.code,
                    }, {
                        'category': mc.name,
                    });
                    newMetric.scale = scale;
                    newMetric.setScore(parseFloat(me.score));
                    metrics.push(newMetric);
                });
            });
            return new Sample_1.Sample({
                "name": sample.name,
                "code": sample.code,
                "reportVersion": sample.report_version,
                "id": sample.id,
                "client": new Client_1.default({ 'name': sample.client.name, 'code': sample.client.code }),
                "parcel": new Tabular_2.ParcelMinimal({ 'name': sample.parcel.name, 'id': sample.parcel.id, 'geodata': sample.parcel.geodata }),
                "crop": new Crop_1.default({
                    "id": sample.crop.id,
                    "name": sample.crop.name,
                    "color": sample.crop.color,
                    "icon": sample.crop.logo
                }),
                "metrics": metrics
            });
        });
        this.samples = samples;
    }
    tabularize() {
        let allFields = [];
        this.farms.forEach((farm) => {
            allFields = [...allFields, ...farm.fields];
        });
        this.fields = allFields;
        this.tabularSet = new Tabular_1.TabularFieldSet(allFields);
    }
    tabularizeSamples() {
        this.tabularSampleSet = new Tabular_2.TabularSampleSet(this.samples);
    }
    async downloadFieldPDF(fieldID) {
        const field = this.fields.find((f) => f.id === fieldID);
        await field.downloadFieldReportAccuratePDF(field.gis_field_id);
    }
    async downloadSamplePDF(sampleID) {
        console.log(sampleID);
        window.open(`/report/pdf/${sampleID}`, '_blank');
    }
    get bioMetricsFarmCategories() {
        return this.scope === 'fields' ?
            this.tabularSet.bioMetricsFarmCategories :
            this.tabularSampleSet.bioMetricsFarmCategories;
    }
    get bioMetrics() {
        return this.scope === 'fields' ?
            this.tabularSet.bioMetrics :
            this.tabularSampleSet.bioMetrics;
    }
    findMetricIxInCategory(code) {
        const allCategories = this.bioMetricsFarmCategories;
        let ix = -1;
        allCategories.forEach((c, i) => {
            const mIx = c.metrics.findIndex((m) => m.code_name === code);
            if (mIx !== -1) {
                ix = i;
                return;
            }
        });
        return ix;
    }
    findMetricIxInColumn(code) {
        const allCategoriesColumns = this.categoriesColumns;
        let ix = -1;
        allCategoriesColumns.forEach((c, i) => {
            const mIx = c.metrics.findIndex((b) => b.code_name === code);
            if (mIx !== -1) {
                ix = i;
                return;
            }
        });
        return ix;
    }
    isFirstMetricInColumn(code) {
        const catIx = this.findMetricIxInColumn(code);
        return (this.categoriesColumns[catIx].metrics.findIndex((m) => m.code_name === code) === 0) ? true : false;
    }
    get acreageMode() {
        if (this.tabularSet.fields.every((f) => f.acreage.unit.startsWith('a'))) {
            return 'ac';
        }
        else if (this.tabularSet.fields.every((f) => f.acreage.unit.startsWith('h'))) {
            return 'ha';
        }
        return 'ac';
    }
    toggleAcreageMode() {
        this.tabularSet.fields.forEach((f) => f.acreage.toggleUnits());
    }
    get categoriesColumns() {
        const transformAggregated = this.bioMetricsFarmCategories.map((afcm) => {
            if (afcm.name.toLowerCase() !== 'diseases') {
                return afcm;
            }
            else {
                const catTransform = afcm;
                catTransform.metrics = catTransform.metrics.filter((bm) => !bm.code_name.startsWith('SO'));
                catTransform.metrics.push(new project_1.BioMetric({
                    name: 'NumDiseases',
                    code_name: 'numDiseases'
                }, {}));
                return catTransform;
            }
        });
        return transformAggregated;
    }
    get metricsColumns() {
        let columns = new Array();
        this.categoriesColumns.forEach((afcm) => {
            // Using public prop to set the first in the category 🤷‍♂️
            const metrics = afcm.metrics.map((m, i) => {
                (i === 0) ? m.public = true : m.public = false;
                return m;
            });
            columns = [...columns, ...metrics];
        });
        return columns;
    }
}
exports.default = TabularController;
